import React, { useEffect, useState } from "react";
import "./personality.css";

// Posters
import cuandoacechalamaldad from "../../movies/temeraria/cuandoacechalamaldad.jpg";
import hereditary from "../../movies/temeraria/hereditary.jpg";
import lesdiaboliques from "../../movies/temeraria/lesdiaboliques.jpg";
import possession from "../../movies/temeraria/possession.jpg";
import psycho from "../../movies/temeraria/psycho.jpg";
import scream from "../../movies/temeraria/scream.jpg";
import theexorcist from "../../movies/temeraria/theexorcist.jpg";
import theothers from "../../movies/temeraria/theothers.jpg";
import theshining from "../../movies/temeraria/theshining.jpg";
import thesilencesofthelambs from "../../movies/temeraria/thesilenceofthelambs.jpg";

const movies = [
  {
    title: "Cuando Acecha la Maldad",
    image: cuandoacechalamaldad,
    director: "Demián Rugna",
    year: 2023,
    cast: "Ezequiel Rodríguez, Demián Salomón",
    synopsis:
      "Los vecinos de un pequeño pueblo rural descubren que un demonio está a punto de nacer entre ellos. Intentan escapar desesperadamente, pero puede que sea demasiado tarde."
  },
  {
    title: "Hereditary",
    image: hereditary,
    director: "Ari Aster",
    year: 2018,
    cast: "Toni Collette, Gabriel Byrne",
    synopsis:
      "Una familia comienza a descubrir secretos oscuros tras la muerte de la matriarca."
  },
  {
    title: "Les Diaboliques",
    image: lesdiaboliques,
    director: "Henri-Georges Clouzot",
    year: 1955,
    cast: "Simone Signoret, Véra Clouzot",
    synopsis:
      "La esposa y la amante de un hombre planean matarlo, pero las cosas no salen como esperan."
  },
  {
    title: "Possession",
    image: possession,
    director: "Andrzej Żuławski",
    year: 1981,
    cast: "Isabelle Adjani, Sam Neill",
    synopsis:
      "Un matrimonio se desmorona mientras la esposa se involucra en eventos sobrenaturales."
  },
  {
    title: "Psycho",
    image: psycho,
    director: "Alfred Hitchcock",
    year: 1960,
    cast: "Anthony Perkins, Janet Leigh",
    synopsis:
      "Un crimen en un motel aislado revela secretos aterradores de su dueño."
  },
  {
    title: "Scream",
    image: scream,
    director: "Wes Craven",
    year: 1996,
    cast: "Neve Campbell, Courteney Cox",
    synopsis:
      "Un asesino enmascarado aterroriza a un pequeño pueblo siguiendo reglas de películas de terror."
  },
  {
    title: "The Exorcist",
    image: theexorcist,
    director: "William Friedkin",
    year: 1973,
    cast: "Ellen Burstyn, Max von Sydow",
    synopsis:
      "Una joven es poseída por un demonio, y dos sacerdotes intentan exorcizarla."
  },
  {
    title: "The Others",
    image: theothers,
    director: "Alejandro Amenábar",
    year: 2001,
    cast: "Nicole Kidman, Fionnula Flanagan",
    synopsis:
      "Una madre vive en una casa aislada con sus hijos fotosensibles, mientras sucesos extraños ocurren."
  },
  {
    title: "The Shining",
    image: theshining,
    director: "Stanley Kubrick",
    year: 1980,
    cast: "Jack Nicholson, Shelley Duvall",
    synopsis:
      "Un hombre y su familia se aíslan en un hotel embrujado durante el invierno, con consecuencias terribles."
  },
  {
    title: "The Silence of the Lambs",
    image: thesilencesofthelambs,
    director: "Jonathan Demme",
    year: 1991,
    cast: "Jodie Foster, Anthony Hopkins",
    synopsis:
      "Una joven agente del FBI busca la ayuda de un asesino encarcelado para atrapar a otro criminal."
  }
];

// ⭐⭐⭐⭐⭐ SVG estrellas (idéntico a Amorosa)
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

// ⭐ Sistema de rating (igual a Amorosa)
function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Temeraria() {
  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMoviesTemeraria") || "{}")
  );

  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("movieRatingsTemeraria") || "{}")
  );

  useEffect(() => window.scrollTo(0, 0), []);

  const toggleSeen = (title) => {
    const s = { ...seen, [title]: !seen[title] };
    setSeen(s);
    localStorage.setItem("seenMoviesTemeraria", JSON.stringify(s));

    if (!s[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("movieRatingsTemeraria", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("movieRatingsTemeraria", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Temeraria</h1>
      <p>
        No le tiene miedo a nada, a diferencia de mí. Bien podría aparecerse el
        diablo que lo recagaría a puteadas y le haría bullying —es la verdadera
        “final girl” de las películas de terror.
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>

                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Temeraria;
